import { Navigate, Route, Routes } from 'react-router-dom';
import { getToken } from './services/api';
import { LoginPage } from './pages/LoginPage';
import { OverviewPage } from './pages/OverviewPage';
import { TenantsPage } from './pages/TenantsPage';
import { UsersPage } from './pages/UsersPage';
import { CompaniesPage } from './pages/CompaniesPage';
import { MedicalCheckupsPage } from './pages/MedicalCheckupsPage';
import { QueueSettingsPage } from './pages/QueueSettingsPage';
import { TemplatesPage } from './pages/TemplatesPage';
import { OnboardingPage } from './pages/OnboardingPage';
import { RabbitMQPage } from './pages/RabbitMQPage';
import { S3StoragePage } from './pages/S3StoragePage';
import { AnalyticsPage } from './pages/AnalyticsPage';
import { EplIntegrationsPage } from './pages/EplIntegrationsPage';
import { MeshCentralPage } from './pages/MeshCentralPage';
import { MeshDevicePage } from './pages/MeshDevicePage';
import { FeatureFlagsProvider, FeatureGate } from './features/FeatureFlags';
import { ActivityCenterProvider } from './features/ActivityCenter';
import { AiAssistantPage } from './pages/AiAssistantPage';

const Protected = ({ children }: { children: JSX.Element }) => getToken() ? children : <Navigate to="/login" replace />;

export const App = () => <ActivityCenterProvider><FeatureFlagsProvider><Routes>
  <Route path="/login" element={<LoginPage />} />
  <Route path="/" element={<Protected><OverviewPage /></Protected>} />
  <Route path="/onboarding" element={<Protected><FeatureGate feature="onboarding"><OnboardingPage /></FeatureGate></Protected>} />
  <Route path="/tenants" element={<Protected><FeatureGate feature="tenants"><TenantsPage /></FeatureGate></Protected>} />
  <Route path="/terminals" element={<Navigate to="/meshcentral" replace />} />
  <Route path="/terminals/:id" element={<Navigate to="/meshcentral" replace />} />
  <Route path="/users" element={<Protected><FeatureGate feature="users"><UsersPage /></FeatureGate></Protected>} />
  <Route path="/companies" element={<Protected><FeatureGate feature="companies"><CompaniesPage /></FeatureGate></Protected>} />
  <Route path="/medical-checkups" element={<Protected><FeatureGate feature="medicalCheckups"><MedicalCheckupsPage /></FeatureGate></Protected>} />
  <Route path="/queue-settings" element={<Protected><FeatureGate feature="queueSettings"><QueueSettingsPage /></FeatureGate></Protected>} />
  <Route path="/document-templates" element={<Protected><FeatureGate feature="documentTemplates"><TemplatesPage /></FeatureGate></Protected>} />
  <Route path="/audit" element={<Navigate to="/" replace />} />
  <Route path="/rabbitmq" element={<Protected><FeatureGate feature="rabbitmq"><RabbitMQPage /></FeatureGate></Protected>} />
  <Route path="/s3-storage" element={<Protected><FeatureGate feature="s3Storage"><S3StoragePage /></FeatureGate></Protected>} />
  <Route path="/bulk-operations" element={<Navigate to="/meshcentral" replace />} />
  <Route path="/analytics" element={<Protected><FeatureGate feature="analytics"><AnalyticsPage /></FeatureGate></Protected>} />
  <Route path="/epl-integrations" element={<Protected><FeatureGate feature="eplIntegrations"><EplIntegrationsPage /></FeatureGate></Protected>} />
  <Route path="/meshcentral" element={<Protected><FeatureGate feature="meshcentral"><MeshCentralPage /></FeatureGate></Protected>} />
  <Route path="/meshcentral/device/:nodeId" element={<Protected><FeatureGate feature="meshcentral"><MeshDevicePage /></FeatureGate></Protected>} />
  <Route path="/ai-assistant" element={<Protected><AiAssistantPage /></Protected>} />
  <Route path="*" element={<Navigate to="/" replace />} />
</Routes></FeatureFlagsProvider></ActivityCenterProvider>;
